// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__e2XNO","NotFoundErrorCode":"NotFoundPage_NotFoundErrorCode__p5unR"};